import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PrinterOutlined } from "@ant-design/icons";
import { Button, Input, Layout, notification } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { connect } from 'react-redux';

import { useDispatch } from 'react-redux';
import Loader from '../../../Home/Loader/Loader';
import { getBatchItems } from '../../../redux/actions/API/batchItems';
import { acceptRejectApproval, getInventoryApprovalById } from '../../../redux/actions/API/inventoryApprovalAction';
import { getAllRejectStoreItems } from '../../../redux/actions/API/stockTransferAction';
import { getAllStoresWithItems, getStores } from '../../../redux/actions/API/storesActions';
import { isValidJSON } from '../../utility/itemsUtility';
import AddSelectBatch from '../BatchCode/AddSelectBatch';
import BarcodePrint from '../BatchCode/BarcodePrint';

interface InventoryPreviewProps {
    getInventoryApprovalById: Function;
    approvalByIdLoading: boolean;
    previewData: any;
    companyId: string;
    acceptRejectApproval: Function;
    acceptRejectApprovalMessage: string;
    acceptRejectApprovalLoading: boolean;
    userId: string;
    loginData: any;
    getBatchItems: Function;
    getAllRejectStoreItems: Function;
    getAllRejectStoreItemsData: any;
    getAllStoresWithItems: Function;
    getAllStoresWithItemsData: any;
    getStores: Function;
    storesData: any;
    settingData: any;
}

const InventoryPreview: React.FC<InventoryPreviewProps> = ({
    getInventoryApprovalById, previewData,
    approvalByIdLoading, companyId, acceptRejectApproval, acceptRejectApprovalMessage,
    acceptRejectApprovalLoading, userId, loginData, getBatchItems,
    getAllRejectStoreItems, getAllRejectStoreItemsData, getAllStoresWithItems, getAllStoresWithItemsData,
    getStores, storesData, settingData
}) => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const approvalId = queryParams.get("approvalId");
    const [items, setItems] = useState<any>([]);
    const [edit, setEdit] = useState(false);
    const [imageUrl, setImageURL] = useState("");
    const [addBatchItems, setAddBatchItems] = useState<any>([]);
    const [removeBatchItems, setRemoveBatchItems] = useState<any>([]);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [printData, setPrintData] = useState<any>([]);
    const [companyName, setCompanyName] = useState("");
    const [storewiseItems, setStoreWiseItems] = useState<any>({});
    const [comment, setComment] = useState("");

    const navigate = useNavigate();

    const dispatch = useDispatch();

    useEffect(() => {
        if (approvalId) {
            getInventoryApprovalById({ approvalId, companyId: Number(companyId) });
        }
    }, [approvalId]);

    useEffect(() => {
        if (companyId && Array.isArray(storesData) && storesData?.length) {
            const storeIds = storesData?.map(data => data.id);
            getAllStoresWithItems({ storeIds });
            getAllRejectStoreItems({ companyId: Number(companyId) });
        }
    }, [storesData]);

    useEffect(() => {
        getStores({ companyId: Number(companyId) });
    }, [companyId]);

    useEffect(() => {
        if (acceptRejectApprovalMessage) {
            notification.open({ type: 'success', message: acceptRejectApprovalMessage, duration: 3 });
            getInventoryApprovalById({ approvalId, companyId: Number(companyId) });
            dispatch({
                type: 'ACCEPT_REJECT_APPROVAL_SUCCESS', payload: {
                    responseData: {
                        message: ''
                    }
                }
            });
        }
    }, [acceptRejectApprovalMessage]);

    useEffect(() => {
        const storeNameMap = storesData?.reduce((acc: any, store: any) => {
            acc[store.id] = store.name;
            return acc;
        }, {});
        const obj: any = {};
        for (const element of getAllStoresWithItemsData) {
            for (const store of element) {
                if (obj[storeNameMap[store.storeId]]) {
                    obj[storeNameMap[store.storeId]][store.itemId.itemId] = store.quantity;
                } else {
                    obj[storeNameMap[store.storeId]] = {};
                    obj[storeNameMap[store.storeId]][store.itemId.itemId] = store.quantity;
                }
            }
        }
        setStoreWiseItems(obj);
    }, [getAllStoresWithItemsData]);

    useEffect(() => {
        if (Array.isArray(previewData?.items)) {
            const formattedItems = previewData.items.map((item: any) => ({
                ...item,
                quantity: previewData?.approvalStatus == 'Pending' ?
                    Math.abs(item.quantityForApproval || 0) : item.quantity,
            }));

            setItems(formattedItems);
            const addItems = previewData?.items.filter((item: any) => item?.quantity > 0 && !item.fromStoreId);
            const removeItems = previewData?.items.filter((item: any) => item.fromStoreId);
            setAddBatchItems(addItems);
            setRemoveBatchItems(removeItems);
        }
    }, [previewData]);

    useEffect(() => {
        if (Array.isArray(previewData?.items)) {
            if (previewData?.approvalStatus != 'Pending' &&
                (previewData?.documentType == "New Item Added" ||
                    previewData?.documentType == "Physical Stock Reconcilation" ||
                    previewData?.documentType == "Stock Update"
                ) &&
                !previewData?.batchesAssigned) {
                let itemIds = [];
                for (const element of previewData?.items) {
                    if (element?.item?.itemId && element?.quantity > 0 && !element.fromStoreId) itemIds.push(element?.item?.itemId);
                }
                itemIds?.length && getBatchItems({ itemIds, companyId, fromApproval: true });
            }
        }
    }, [previewData]);

    useEffect(() => {
        if (loginData?.data?.role == 1 || loginData?.data?.role == 2) {
            setEdit(true);
        }
        else {
            const subfeature = loginData?.data?.permissions?.find((data: any) => data?.feature == "Inventory" && data?.subfeature == "Inventory Approval");
            if (subfeature && subfeature?.edit) {
                setEdit(true);
            }
        }
        if (loginData?.data?.token) {
            const tokenParts = loginData?.data?.token.split('.');
            if (tokenParts.length !== 3) return;
            const payload = tokenParts[1];
            const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
            const decodedPayload = atob(base64);
            const data = JSON.parse(decodedPayload);
            if (data?.logoUrl) {
                setImageURL(data?.logoUrl)
            }
            setCompanyName(data?.companyName || "");
        }
    }, [loginData]);

    const isAnyOutOfStock = items?.some((record: any) => {
        if (record?.fromStore) {
            const availableQty = record?.isRejected ?
                (getAllRejectStoreItemsData?.[record?.fromStore]?.[record?.item?.itemId] || 0) :
                (storewiseItems?.[record?.fromStore]?.[record?.item?.itemId] || 0);
            return Number(record.quantity) > availableQty;
        }
        return false;
    });

    return (
        <Layout className="layout">
            <Loader loading={approvalByIdLoading || acceptRejectApprovalLoading} />
            <AddSelectBatch
                isDrawerOpen={isDrawerOpen}
                setIsDrawerOpen={setIsDrawerOpen}
                itemsData={addBatchItems}
                selectedItemsData={removeBatchItems}
                approvalId={approvalId}
            />
            <BarcodePrint
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                data={printData}
            />
            <div style={{ textAlign: 'right' }}>
                {(previewData?.approvalStatus == 'Pending' && (loginData?.data?.role == 1 || loginData?.data?.role == 2 || edit)) && <>
                    <Button type="link" disabled={isAnyOutOfStock} onClick={() => {
                        acceptRejectApproval({
                            approvalId: previewData.id,
                            approvedBy: Number(userId),
                            isApproved: true,
                            items,
                            by: loginData?.data?.name,
                            comment: comment?.trim?.() || ''
                        })
                    }}>
                        Approve
                    </Button>
                    <Button type="link" onClick={() => {
                        acceptRejectApproval({
                            approvalId: previewData.id,
                            approvedBy: Number(userId),
                            isApproved: false,
                            items,
                            by: loginData?.data?.name,
                            comment: comment?.trim?.() || ''
                        })
                    }}>
                        Reject
                    </Button>
                </>}
                {previewData?.approvalStatus != 'Pending' &&
                    (previewData?.documentType == "New Item Added" ||
                        previewData?.documentType == "Physical Stock Reconcilation" ||
                        previewData?.documentType == "Stock Update"
                    ) &&
                    !previewData?.batchesAssigned
                    && <Button type="link" onClick={() => {
                        setIsDrawerOpen(true);
                    }}>
                        {
                            previewData?.documentType == "New Item Added" ? "Add Batches" : "Select/Add Batches"
                        }
                    </Button>}
                {previewData?.approvalStatus != 'Pending' &&
                    (previewData?.documentType == "New Item Added" ||
                        previewData?.documentType == "Physical Stock Reconcilation" ||
                        previewData?.documentType == "Stock Update"
                    ) &&
                    previewData?.batchesAssigned
                    && <Button type="link" onClick={() => {
                        const temp: any = [];
                        for (const element of items) {
                            if (Array.isArray(element.batches) && !element.fromStore) {
                                for (const item of element.batches) {
                                    const barcode = isValidJSON(item?.barCodeNumber) || {};
                                    temp.push({
                                        BarcodeNumber: barcode.prefix + barcode.number,
                                        quantity: item.quantity,
                                        itemId: element?.item?.itemId,
                                        itemName: element?.item?.itemName,
                                        uom: element?.item?.metricsUnit,
                                        companyId: item.companyId,
                                        expiryDate: item.expiryDate,
                                        manufacturingDate: item.manufacturingDate
                                    });
                                }
                            }
                        }
                        setPrintData(temp);
                        setIsVisible(true);
                    }}>
                        Preview Barcode
                    </Button>}
                <Button type='link' onClick={() => window.print()}>
                    <PrinterOutlined /> Print
                </Button>
            </div>
            <Content id="documentContainer" className="content-section" style={{ overflowY: 'auto' }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: '40px' }}>
                    {imageUrl ? <img alt="Inventory Approval" src={imageUrl} /> : <div></div>}
                    <h5>Inventory Approval Slip</h5>
                    <div></div>
                </div>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                        <tr>
                            <td style={{ border: "1px solid black", padding: "8px", fontWeight: "bold", width: "20%" }}>
                                Company:
                            </td>
                            <td style={{ border: "1px solid black", padding: "8px", width: "30%" }}>
                                <div style={{ height: "16px" }}>{companyName}</div>
                            </td>
                            <td style={{ border: "1px solid black", padding: "8px", fontWeight: "bold", width: "20%" }}>
                                Slip No:
                            </td>
                            <td style={{ border: "1px solid black", padding: "8px", width: "30%" }}>
                                <div style={{ height: "16px" }}>{previewData?.approvalId}</div>
                            </td>
                        </tr>

                        <tr>
                            <td style={{ border: "1px solid black", padding: "8px", fontWeight: "bold" }}>
                                Document Type:
                            </td>
                            <td style={{ border: "1px solid black", padding: "8px" }}>
                                <div style={{ height: "16px" }}>{previewData?.documentType}</div>
                            </td>
                            <td style={{ border: "1px solid black", padding: "8px", fontWeight: "bold" }}>
                                {previewData?.productionData?.productionId ? 'Production Id' : 'Document Number'}:
                            </td>
                            <td style={{ border: "1px solid black", padding: "8px" }}>
                                <span
                                    className='link'
                                    onClick={() => {
                                        if (!previewData?.documentNumber) return;
                                        if (previewData?.productionData?.productionId) {
                                            previewData?.bulkProductionId ? navigate(
                                                `/view-bulk-production?productionId=${previewData?.bulkProductionId}`
                                            ) : navigate(
                                                `/view_production?productionId=${previewData?.documentNumber}`
                                            );
                                        } else {
                                            navigate(
                                                `/previewDocument?documentNumber=${previewData?.documentNumber}`
                                            );
                                        }
                                    }}
                                >
                                    {previewData?.bulkProductionNumber || previewData?.productionData?.productionId ||
                                        previewData?.documentNumber}
                                </span>
                            </td>
                        </tr>

                        <tr>
                            <td style={{ border: "1px solid black", padding: "8px", fontWeight: "bold" }}>
                                Requested By:
                            </td>
                            <td style={{ border: "1px solid black", padding: "8px" }}>
                                <div style={{ height: "16px" }}>{previewData?.requestedBy}</div>
                            </td>
                            <td style={{ border: "1px solid black", padding: "8px", fontWeight: "bold" }}>
                                Requested Date:
                            </td>
                            <td style={{ border: "1px solid black", padding: "8px" }}>
                                <div style={{ height: "16px" }}>{new Date(previewData?.createdAt).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    timeZone: "Asia/Kolkata",
                                })}</div>
                            </td>
                        </tr>
                        {(previewData?.productionData?.productionId && (previewData?.documentType === "Raw Material"
                            || previewData?.documentType === "Scrap Material")) && <tr>
                                <td style={{ border: "1px solid black", padding: "8px", fontWeight: "bold" }}>
                                    Finished Good Item Id:
                                </td>
                                <td style={{ border: "1px solid black", padding: "8px" }}>
                                    <div style={{ height: "16px" }}>{previewData?.productionData?.finishedGood?.itemId}</div>
                                </td>
                                <td style={{ border: "1px solid black", padding: "8px", fontWeight: "bold" }}>
                                    Finished Good Item Name:
                                </td>
                                <td style={{ border: "1px solid black", padding: "8px" }}>
                                    <div style={{ height: "16px" }}>{previewData?.productionData?.finishedGood?.itemName}</div>
                                </td>
                            </tr>}
                    </tbody>
                </table>
                <br />
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                        {/* Header Row */}
                        <tr>
                            <td style={{ border: "1px solid black", padding: "6px", fontWeight: "bold" }}>
                                Approve By
                            </td>
                            <td style={{ border: "1px solid black", padding: "6px", fontWeight: "bold" }}>
                                Status
                            </td>
                            <td style={{ border: "1px solid black", padding: "6px", fontWeight: "bold" }}>
                                Approve Date
                            </td>
                            <td style={{ border: "1px solid black", padding: "6px", fontWeight: "bold" }}>
                                Comment
                            </td>
                        </tr>

                        {/* Input Line Row */}
                        <tr>
                            <td style={{ border: "1px solid black", padding: "10px" }}>
                                <div style={{ height: "20px" }}>{previewData?.approvalStatus === "Pending" ? "Approval Pending" : previewData?.approvedBy || "Auto Approved"}</div>
                            </td>
                            <td style={{ border: "1px solid black", padding: "10px" }}>
                                <div style={{ height: "20px" }}>{previewData?.approvalStatus || ""}</div>
                            </td>
                            <td style={{ border: "1px solid black", padding: "10px" }}>
                                <div style={{ height: "20px" }}>{previewData?.approvalStatus === "Auto Approved" ? new Date(previewData?.createdAt).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    timeZone: "Asia/Kolkata",
                                }) : previewData?.approvalDate ? new Date(previewData.approvalDate).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    timeZone: "Asia/Kolkata",
                                }) : ""}</div>
                            </td>
                            <td style={{ border: "1px solid black", padding: "10px" }}>
                                {previewData?.approvalStatus === "Pending" ? <Input maxLength={100} placeholder='Enter Comment (max 100 characters)' onChange={(e) => setComment(e.target.value)} value={comment || ""} style={{ height: "30px" }} /> : <>{previewData?.comment}</>}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br />
                {(previewData?.approvalStatus === "Pending" ||
                    settingData?.inventorySlipTemplate === "" ||
                    (previewData?.documentType != "Finished Good" &&
                        previewData?.documentType != "Raw Material" &&
                        previewData?.documentType != "Scrap Material" &&
                        previewData?.documentType != "Raw Material Return")

                ) ? <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                        <tr>
                            <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>S.No</th>
                            <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>Item</th>
                            <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>Store</th>
                            <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>Type</th>
                            {previewData?.approvalStatus === 'Pending' && <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>Available Qty</th>}
                            <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>Req Qty</th>
                            <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>App Qty</th>
                            <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>Comment</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items?.filter((item: any) => item?.fromStore || item?.toStore)?.map((record: any, index: number) => (
                            <tr key={index}>
                                <td style={{ border: "1px solid black", padding: "8px" }}>{index + 1}</td>
                                <td style={{ border: "1px solid black", padding: "8px" }}>
                                    <div>
                                        <div>{record?.item?.itemId || ""}</div>
                                        <div>{record?.item?.itemName || ""}</div>
                                    </div>
                                </td>
                                <td style={{ border: "1px solid black", padding: "8px" }}>
                                    <div>
                                        <div><strong>From:</strong> {record?.fromStore || "N/A"}</div>
                                        <div><strong>To:</strong> {record?.toStore || "N/A"}</div>
                                    </div>
                                </td>
                                <td style={{ border: "1px solid black", padding: "8px" }}>
                                    {record?.isRejected ? 'Reject' : 'Instock'}
                                </td>
                                {previewData?.approvalStatus === 'Pending' && <td style={{ border: "1px solid black", padding: "8px" }}>
                                    <div>
                                        {!record?.fromStore ? "" : record?.isRejected ?
                                            (getAllRejectStoreItemsData?.[record?.fromStore]?.[record?.item?.itemId] || 0)?.toFixed?.(2)
                                            :
                                            (storewiseItems?.[record?.fromStore]?.[record?.item?.itemId] || 0)?.toFixed?.(2)}
                                    </div>
                                </td>}
                                <td style={{ border: "1px solid black", padding: "8px" }}>
                                    <div>
                                        <div>{Math.abs(record?.quantityForApproval || 0)?.toFixed?.(2)}: {record?.item?.metricsUnit}</div>
                                        {record?.item?.alternateUnits?.map((unit: any, ind: number) => (
                                            <div key={ind}>{(Math.abs(record?.quantityForApproval || 0) / (unit?.conversionfactor || 1))?.toFixed?.(2)}: {unit?.alternateUnit}</div>
                                        ))}
                                    </div>
                                </td>
                                <td style={{ border: "1px solid black", padding: "8px" }}>
                                    {previewData?.approvalStatus === 'Pending' ? (
                                        <>
                                            <Input
                                                value={record.quantity}
                                                type='number'
                                                disabled={previewData?.documentType == "Finished Good"}
                                                size="small"
                                                onChange={(e) => {
                                                    const arr = [...items];
                                                    arr[index] = {
                                                        ...arr[index],
                                                        quantity: e.target.value
                                                    };
                                                    setItems(arr);
                                                }}
                                            />
                                            {(() => {
                                                if (record?.fromStore) {
                                                    const availableQty = record?.isRejected ?
                                                        (getAllRejectStoreItemsData?.[record?.fromStore]?.[record?.item?.itemId] || 0) :
                                                        (storewiseItems?.[record?.fromStore]?.[record?.item?.itemId] || 0);
                                                    if (Number(record.quantity) > availableQty) {
                                                        return <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>Out of stock</div>;
                                                    }
                                                }
                                                return null;
                                            })()}
                                        </>
                                    ) : (
                                        <div>
                                            <div>{((record?.fromStore === record?.toStore || record?.quantityForApproval < record?.quantity) ? record.quantity / 2 : record.quantity)?.toFixed?.(2)}: {record?.item?.metricsUnit}</div>
                                            {record?.item?.alternateUnits?.map((unit: any, ind: number) => (
                                                <div key={ind}>{(((record?.fromStore === record?.toStore || record?.quantityForApproval < record?.quantity) ? record.quantity / 2 : record.quantity) / (unit?.conversionfactor || 1))?.toFixed?.(2)}: {unit?.alternateUnit}</div>
                                            ))}
                                        </div>
                                    )}
                                </td>
                                <td style={{ border: "1px solid black", padding: "8px" }}>
                                    {record?.comment || "N/A"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table> : <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                        <tr>
                            <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>S.No</th>
                            <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>Item</th>
                            <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>Description</th>
                            <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>Store</th>
                            <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>Qty</th>
                            <th style={{ border: "1px solid black", padding: "8px", textAlign: "left" }}>Comment</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items?.map((record: any, index: number) => (
                            <tr key={index}>
                                <td style={{ border: "1px solid black", padding: "8px" }}>{index + 1}</td>
                                <td style={{ border: "1px solid black", padding: "8px" }}>
                                    {record?.item?.itemId || ""}
                                </td>
                                <td style={{ border: "1px solid black", padding: "8px" }}>
                                    {record?.item?.itemName || ""}
                                </td>
                                <td style={{ border: "1px solid black", padding: "8px" }}>
                                    {record?.fromStore || record?.toStore}
                                </td>
                                <td style={{ border: "1px solid black", padding: "8px" }}>
                                    <div>
                                        {[
                                            `${((record?.fromStore === record?.toStore || record?.quantityForApproval < record?.quantity) ? record.quantity / 2 : record.quantity)?.toFixed?.(2)}: ${record?.item?.metricsUnit}`,

                                            ...(record?.item?.alternateUnits?.map((unit: any) =>
                                                `${(((record?.fromStore === record?.toStore || record?.quantityForApproval < record?.quantity) ? record.quantity / 2 : record.quantity) / (unit?.conversionfactor || 1))?.toFixed?.(2)}: ${unit?.alternateUnit}`
                                            ) || [])
                                        ].join(", ")}
                                    </div>
                                </td>
                                <td style={{ border: "1px solid black", padding: "8px" }}>
                                    {record?.comment || "N/A"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                }

            </Content>
        </Layout>
    )
}

const mapStateToProps = (state: any) => ({
    approvalByIdLoading: state.api.getInventoryApprovalById.loading,
    previewData: state.api.getInventoryApprovalById.data,
    companyId: state.api.login.data.companyId,
    acceptRejectApprovalLoading: state.api.acceptRejectApproval.loading,
    acceptRejectApprovalMessage: state.api.acceptRejectApproval.data,
    userId: state.api.login.data.id,
    loginData: state.api.login,
    getAllStoresWithItemsData: state.api.getAllStoresWithItems?.getAllStoresWithItemsData,
    getAllRejectStoreItemsData: state.api.getAllRejectStoreItems?.data,
    storesData: state.api.getStore?.data,
    settingData: state.api.getSetting?.data,
});

const mapDispatchToProps = (dispatch: any) => ({
    getInventoryApprovalById: (payload: any) => dispatch(getInventoryApprovalById(payload)),
    acceptRejectApproval: (payload: any) => dispatch(acceptRejectApproval(payload)),
    getBatchItems: (payload: any) => dispatch(getBatchItems(payload)),
    getAllStoresWithItems: (payload: any) => dispatch(getAllStoresWithItems(payload)),
    getAllRejectStoreItems: (payload: any) => dispatch(getAllRejectStoreItems(payload)),
    getStores: (payload: any) => dispatch(getStores(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InventoryPreview);
